export function MessageForTag(props) {

    var type = props.type
    var colourBG = "bg-gray-100"
    var colourTX = "text-gray-500"
    var colourBO = "border-gray-500"

    return (<div className={`${colourBG} rounded-md border-solid border ${colourBO} flex justify-center px-3 ${colourTX}`}> {type} </div>);
}